import { createContext, useContext } from 'react';
import 'goober';
export var appColors = {
    neutral: {
        w50: '#F6F9FC',
        w100: '#F2F4F9',
        w200: '#E9EEF5',
        w300: '#E4E9F0',
        w400: '#DFE4EB',
        w500: '#AAC0DA',
        w600: '#8AA5C5',
        w700: '#6B83A0',
        w800: '#506D8F',
        w900: '#3E546E',
    },
    primary: {
        w50: '#E2EDFF',
        w300: '#9DC2FF',
        w500: '#3B85FF',
        w700: '#1B56B8',
        w900: '#103573',
    },
    secondary: {
        w50: '#EAE0F4',
        w300: '#BC99E0',
        w500: '#7933C0',
        w700: '#541C8C',
        w900: '#380A66',
    },
    function: {
        w50: '#D8F3F4',
        w300: '#84D8DD',
        w500: '#09B1BC',
        w700: '#009099',
        w900: '#00484C',
    },
    success: {
        w50: '#E6F9EE',
        w300: '#97E5B8',
        w500: '#2ECC71',
        w700: '#0E8C44',
        w900: '#084C25',
    },
    warning: {
        w50: '#FFF7ED',
        w300: '#FBC380',
        w500: '#F88600',
        w700: '#B26000',
        w900: '#663700',
    },
    error: {
        w50: '#FCEAE8',
        w300: '#F3A59D',
        w500: '#E74C3C',
        w700: '#BF2C1D',
        w900: '#80170D',
    },
    ui: {
        white: '#FFFFFF',
        dark: '#001024',
        transparent: '#FFFFFF00',
    },
};
var theme = {
    colors: appColors,
    font: {
        size: '12px',
        smallSize: '11px',
        formSize: '12px',
        formSizeSmall: '11px',
    },
    borderRadius: '3px',
    space: {
        xs: '2px',
        s: '5px',
        m: '10px',
        l: '15px',
        xl: '20px',
    },
    borderColor: '#E9EEF5',
    boxShadow: 'rgba(107, 131, 160, 0.15)',
};
var ThemeContext = createContext(theme);
var useTheme = function () { return useContext(ThemeContext); };
export default useTheme;
